import React from "react";

import { Button, Menu, MenuItem, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

import Spacer from "components/Spacer";

import { useAppDispatch, useAppSelector } from "store";
import {
    StoreSortField,
    selectStoresSort,
    setStoresSort
} from "modules/customer/insights/cost/filters/filtersSlice";

import { SortDirection } from "utils/sortUtils";

const StyledMenu = withStyles(theme => ({
    list: {
        width: theme.spacing(40)
    }
}))(Menu);

const StyledMenuItem = withStyles(theme => ({
    root: {
        fontWeight: (props: any) => props["data-current"] ? "bold" : "normal",
        color: (props: any) => props["data-current"] ? theme.palette.text.primary : theme.palette.text.disabled
    }
}))(MenuItem);

const Sort: React.FC = () => {
    const dispatch = useAppDispatch();
    const storesSort = useAppSelector(selectStoresSort);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSortClick = (field: StoreSortField, sort: SortDirection) => () => {
        let direction = sort;
        if (storesSort.field === field) {
            direction = storesSort.direction === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
        }
        const newStoreSort = { ...storesSort, field, direction };
        dispatch(setStoresSort(newStoreSort));
    };

    return (
        <>
            <Button
                variant="text"
                size="small"
                color="default"
                disableElevation
                startIcon={<ArrowDownwardIcon />}
                onClick={handleClick}
                data-cy="btn-sort"
            >
                Sort
            </Button>
            <StyledMenu
                open={open}
                onClose={handleClose}
                variant="menu"
                keepMounted
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                <StyledMenuItem onClick={handleSortClick(StoreSortField.OpportunityValue, SortDirection.DESC)} data-current={storesSort.field === StoreSortField.OpportunityValue}>
                    <Typography variant="body1" component="div">Opportunity value (&pound;)</Typography>
                    <Spacer />
                    {storesSort.field !== StoreSortField.OpportunityValue || storesSort.direction === SortDirection.DESC ? (
                        <ArrowDownwardIcon fontSize="small" />
                    ) : (
                        <ArrowUpwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.OpportunityValuePercentage, SortDirection.DESC)} data-current={storesSort.field === StoreSortField.OpportunityValuePercentage}>
                    <Typography variant="body1" component="div">Opportunity value (%)</Typography>
                    <Spacer />
                    {storesSort.field !== StoreSortField.OpportunityValuePercentage || storesSort.direction === SortDirection.DESC ? (
                        <ArrowDownwardIcon fontSize="small" />
                    ) : (
                        <ArrowUpwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.AverageSimilarityScore, SortDirection.DESC)} data-current={storesSort.field === StoreSortField.AverageSimilarityScore}>
                    <Typography variant="body1" component="div">Average similarity score (%)</Typography>
                    <Spacer />
                    {storesSort.field !== StoreSortField.AverageSimilarityScore || storesSort.direction === SortDirection.DESC ? (
                        <ArrowDownwardIcon fontSize="small" />
                    ) : (
                        <ArrowUpwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.CostAsPercentageOfRevenue, SortDirection.DESC)} data-current={storesSort.field === StoreSortField.CostAsPercentageOfRevenue}>
                    <Typography variant="body1" component="div">Cost as % of revenue</Typography>
                    <Spacer />
                    {storesSort.field !== StoreSortField.CostAsPercentageOfRevenue || storesSort.direction === SortDirection.DESC ? (
                        <ArrowDownwardIcon fontSize="small" />
                    ) : (
                        <ArrowUpwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.CostValue, SortDirection.DESC)} data-current={storesSort.field === StoreSortField.CostValue}>
                    <Typography variant="body1" component="div">Cost value</Typography>
                    <Spacer />
                    {storesSort.field !== StoreSortField.CostValue || storesSort.direction === SortDirection.DESC ? (
                        <ArrowDownwardIcon fontSize="small" />
                    ) : (
                        <ArrowUpwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.StoreName, SortDirection.ASC)} data-current={storesSort.field === StoreSortField.StoreName}>
                    <Typography variant="body1" component="div">
                        Store name
                    </Typography>
                    <Spacer />
                    <Typography variant="body1" component="div">
                        {storesSort.field !== StoreSortField.StoreName || storesSort.direction === SortDirection.ASC ? "A-Z" : "Z-A"}
                    </Typography>
                </StyledMenuItem>
            </StyledMenu>
        </>
    );
};

export default Sort;
